import {
  About,
  Footer,
  Header,
  Navbar,
  Skills,
  Testimonials,
  Works,
} from './layout'
import './App.scss'
import { useContext } from 'react'
import { DarkThemeContext } from './utilities/DarkTheme'

function App() {
  const { darkToggle, setDarkToggle } = useContext(DarkThemeContext)

  return (
    <div className={`app ${darkToggle && 'dark'}`}>
      <Navbar darkToggle={darkToggle} setDarkToggle={setDarkToggle} />
      <main>
        <Header darkToggle={darkToggle} />
        <About />
        <Works />
        <Skills />
        <Testimonials />
      </main>
      <Footer />
    </div>
  )
}

export default App
